export default {
  labelMaintenanceTemplate: 'LABEL_MAINTENANCE_TEMPLATE',
  labelMaintenanceName: 'LABEL_MAINTENANCE_NAME',
  labelMaintenanceDescription: 'LABEL_MAINTENANCE_DESCRIPTION',
  labelMaintenanceType: 'LABEL_MAINTENANCE_TYPE',
  labelMaintenanceState: 'LABEL_MAINTENANCE_STATE',
  labelMaintenanceMethod:'LABEL_MAINTENANCE_METHOD',
  labelMaintenanceIntervalType:'LABEL_MAINTENANCE_INTERVAL_TYPE',
  labelMaintenanceInterval:'LABEL_MAINTENANCE_INTERVAL',
  labelMaintenanceAlertPreDelay:'LABEL_MAINTENANCE_ALERT_PRE_DELAY',
  labelMaintenanceManager:'LABEL_MAINTENANCE_MANAGER',
  labelMaintenanceContractor:'LABEL_MAINTENANCE_CONTRACTOR',
  labelMaintenanceEquipementCategorie:'LABEL_MAINTENANCE_EQUIPEMENT_CATGORIE',
  labelMaintenanceEquipementSousCategorie:'LABEL_MAINTENANCE_EQUIPEMENT_SOUS_CATGORIE',
  labelMaintenanceEquipement:'LABEL_MAINTENANCE_EQUIPEMENT',
  labelMaintenanceAttribute:'LABEL_MAINTENANCE_ATTRIBUTE',
  labelMaintenanceUseAsTemplate:'LABEL_MAINTENANCE_USE_AS_TEMPLATE',
  labelMaintenanceshowAllContractor:'LABEL_MAINTENANCE_SHOW_ALL_CONTRACTOR',
  labelMaintenanceDate:'LABEL_MAINTENANCE_DATE',
  labelTemplateMaintenanceName: 'LABEL_TEMPLATE_MAINTENANCE_NAME',
  labelTemplateMaintenanceDescription: 'LABEL_TEMPLATE_MAINTENANCE_DESCRIPTION',
  labelAttributValue:'LABEL_ATTRIBUT_VALUE',
  labelAttributCurrentValue:'LABEL_ATTRIBUT_CURRENT_VALUE',
  listingMaintenanceManager:'LISTING_MAINTENANCE_MANAGER',
  listingMaintenanceAssigned: 'LISTING_MAINTENANCE_ASSIGNED',
  listingMaintenanceState: 'LISTING_MAINTENANCE_STATE',
  listingMaintenanceLblState: {
    enabled: 'MAINTENANCE_LBL_STATE_ENABLED',
    disabled: 'MAINTENANCE_LBL_STATE_DISABLED',
    waiting: 'MAINTENANCE_LBL_STATE_WAITING',
    done: 'MAINTENANCE_LBL_STATE_DONE',
    triggered: 'MAINTENANCE_LBL_STATE_TRIGGERED',
    archived: 'MAINTENANCE_LBL_STATE_ARCHIVED',
  },
  listingMaintenanceMethod: 'LISTING_MAINTENANCE_METHOD',
  listingMaintenanceLblMethod: {
    auto: 'MAINTENANCE_LBL_METHOD_AUTO',
    manual: 'MAINTENANCE_LBL_METHOD_MANUAL'
  },
  listingMaintenanceLastAction: 'LISTING_MAINTENANCE_LAST_ACTION',
  listingMaintenanceContractor: 'LISTING_MAINTENANCE_CONTRACTOR',
  listingMaintenanceLblType: {
    mandatory: 'MAINTENANCE_LBL_TYPE_MANDATORY',
    internal: 'MAINTENANCE_LBL_TYPE_INTERNAL',
    external: 'MAINTENANCE_LBL_TYPE_EXTERNAL',
  },
  filterMaintenanceType: 'FILTER_MAINTENANCE_TYPE',
  filterMaintenanceState: 'FILTER_MAINTENANCE_STATE',
  filterMaintenanceMethod:'FILTER_MAINTENANCE_METHOD',
  filterMaintenanceCreator:'FILTER_MAINTENANCE_CREATOR',
  filterMaintenanceManager:'FILTER_MAINTENANCE_MANAGER',
  filterMaintenanceContractor:'FILTER_MAINTENANCE_CONTRACTOR',
  filterMaintenanceEquipmentCategory:'FILTER_MAINTENANCE_EQUIPMENT_CATGORY',
  filterMaintenanceEquipmentSubCategory:'FILTER_MAINTENANCE_EQUIPMENT_SUB_CATGORY',
  requireAttributeValSuperior:'REQUIRE_ATTRIBUT_VALUE_SUPERIOR',
}



// WEBPACK FOOTER //
// ./src/locales/maintenance/index.ts